import {
  rowDelimiter,
  colDelimiter,
  keyValueDelimiter,
  decode,
  encode,
} from "./genericHelper";

export const propNamesPapSmears = {
  numberOfTimes: "numberOfTimes",
  date: "date",
  drpPapSmear: "abnormality",
  otherPapSmear: "otherAbnormality",
  drpTreatment: "treatment",
  otherTreatment: "otherTreatment",
};

export const transformMultiAbnormalPapsInput = (id, val) => {
  // eslint-disable-next-line max-len
  // "[2]date^2017-04-04T18:02:50.050Z~treatment^~otherTreatment^~provider^progui1|date^2015-05-04T18:03:07.865Z~treatment^~otherTreatment^~provider^progui1";
  let returnObj = {};
  let isInComplete = false;
  let numberOfTimes;
  if (val) {
    numberOfTimes = val.slice(0, val.indexOf("]") + 1).slice(1, -1);
    const strippedHosp = val.replace(val.slice(0, val.indexOf("]") + 1), "");
    returnObj = { ...returnObj, [`${id}-numberOfTimes`]: numberOfTimes };
    const rows = strippedHosp.split(rowDelimiter);

    if (rows.length) {
      rows.forEach(async (el, index) => {
        if (el && el !== "") {
          const cols = el.split(colDelimiter);
          if (cols.length > 0) {
            cols.forEach((col) => {
              const keyValueArr = col.split(keyValueDelimiter);

              if (keyValueArr.length > 0) {
                const key = keyValueArr[0];
                let value = keyValueArr[1];
                if (
                  (key === propNamesPapSmears.date ||
                    key === propNamesPapSmears.drpPapSmear ||
                    key === propNamesPapSmears.drpTreatment) &&
                  (value === undefined || value === "")
                ) {
                  isInComplete = true;
                }

                if (value && value !== "") {
                  if (key === propNamesPapSmears.date) {
                    value = new Date(value);
                  }
                  if (key === propNamesPapSmears.otherPapSmear) {
                    value = decode(value);
                  }
                  if (key === propNamesPapSmears.otherTreatment) {
                    value = decode(value);
                  }
                  returnObj = {
                    ...returnObj,
                    [`${id}-${index}-${key}`]: value,
                  };
                }
              }
            });
          }
        }
      });

      // await Promise.all(promises);
    }
    if (!isInComplete && numberOfTimes && parseInt(numberOfTimes, 10) < 0) {
      isInComplete = true;
    }
  }
  return { numberOfTimes, responses: returnObj, isComplete: !isInComplete };
};

export const transformMultiAbnormalPapsOutput = (
  id,
  value,
  responseCollection
) => {
  let returnVal = "";
  const numberOfTimes = value;
  let isInComplete = false;
  if (
    numberOfTimes < 0 ||
    numberOfTimes === null ||
    numberOfTimes === undefined
  ) {
    isInComplete = true;
  }

  if (numberOfTimes > 0) {
    [...Array(numberOfTimes)].forEach((el, index) => {
      const date =
        responseCollection[`${id}-${index}-${propNamesPapSmears.date}`];
      const drpPapSmear =
        encode(
          responseCollection[`${id}-${index}-${propNamesPapSmears.drpPapSmear}`]
        ) || "";
      const otherPapSmear =
        encode(
          responseCollection[
            `${id}-${index}-${propNamesPapSmears.otherPapSmear}`
          ]
        ) || "";
      const drpTreatment =
        encode(
          responseCollection[
            `${id}-${index}-${propNamesPapSmears.drpTreatment}`
          ]
        ) || "";
      const otherTreatment =
        encode(
          responseCollection[
            `${id}-${index}-${propNamesPapSmears.otherTreatment}`
          ]
        ) || "";

      if (
        !date ||
        date === "" ||
        !drpPapSmear ||
        drpPapSmear === "" ||
        !drpTreatment ||
        drpTreatment === ""
      ) {
        isInComplete = true;
      }

      let dateStr = "";
      try {
        dateStr = date ? date?.toISOString() : ``;
        // eslint-disable-next-line no-empty
      } catch {
        isInComplete = true;
      }

      returnVal += `${propNamesPapSmears.date}${keyValueDelimiter}${dateStr}${colDelimiter}${propNamesPapSmears.drpPapSmear}${keyValueDelimiter}${drpPapSmear}${colDelimiter}${propNamesPapSmears.otherPapSmear}${keyValueDelimiter}${otherPapSmear}${colDelimiter}${propNamesPapSmears.drpTreatment}${keyValueDelimiter}${drpTreatment}${colDelimiter}${propNamesPapSmears.otherTreatment}${keyValueDelimiter}${otherTreatment}${rowDelimiter}`;
    });
  }

  return {
    transformedValue: `[${numberOfTimes}]${returnVal.slice(0, -1)}`,
    isComplete: !isInComplete,
  };
};
